export default __webpack_public_path__ + "static/media/Carosel HO 3.08a62337.svg";